import { render } from "./Playtable.vue?vue&type=template&id=c8b09514&ts=true"
import script from "./Playtable.vue?vue&type=script&lang=ts"
export * from "./Playtable.vue?vue&type=script&lang=ts"

import "./Playtable.vue?vue&type=style&index=0&id=c8b09514&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__